import Cookies from 'js-cookie';
import { isMobile } from 'react-device-detect';
export const isDebugAnalytics = true;

type CookieIubType = {
  timestamp: string, version: string,
  purposes: { 1: boolean, 2: boolean, 3: boolean, 4: boolean, 5: boolean },
  id: number, cons: { rand: string }
};

const commonParams = () => {
  const platform = Cookies.get('platform') ?? 'web';
  let uid = 'unknown';
  if (uid) {
    const cookieIubStr: string | undefined = Cookies.get('_iub_cs-69989687');
    if (cookieIubStr) {
      const cookieIub: CookieIubType = JSON.parse(cookieIubStr);
      if (cookieIub.purposes[4] === true) {
        uid = Cookies.get('uid') ?? 'unknown';
      }
    }
  }
  let deviceType = '';
  if (platform === 'web') {
    if (isMobile) {
      deviceType = 'mobile';
    } else {
      deviceType = 'desktop';
    }
  } else {
    //ios o android
    deviceType = platform;
  }
  return {
    nonInteraction: false,
    userid: uid,
    platform: platform,
    device_type: deviceType,
  };
};
export const GaAnalytics = {
  sendEvent: (eventName: string, params?: any): void => {
    let tempParams: any = {};
    if (params) {
      tempParams = { ...commonParams(), ...params };
    } else {
      tempParams = { ...commonParams() };
    }
    if (isDebugAnalytics) {
      console.log(`EVENT: ${eventName}`, `\nparams: ${JSON.stringify(tempParams)}`);
    }
    window.gtag('event', eventName, tempParams);

  },
};
